module.exports = __webpack_public_path__ + "img/87.81fd59a0.png";